module.exports = __webpack_public_path__ + "img/Goal_3.5f9226a1.png";